import React from "react";
// import salesAnalyticsImg from "./MonthlyIncomingItems.png";
// import ordersFromImg from "./POReceivedbySuppliers.png";
// import NumberCategoryImg from "./PickingAccuracy.png";
// import inventoryTurnoverImg from "./WarehousingCosts.png";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import DashboardTablesRender from "../DashboardTablesRender";
import { WarehouseCardData } from "../Dashboard card data";
import { INVENTORYDBSupplierTableData } from "../DashboardTablesData";
import SingleLineChart from "../SingleLineChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PieGraph from "../BI/PieGraph";
import WarehouseBarChart from "../WarehouseBarChart";
import { WareHouseLineData } from "../SingleLineChartData";
import DotsComponent from "../DotsComponent";
import './Warehouse.css';
import WarehouseDashTable from "./Components/WarehouseDashTable";
import GraphLabel2 from "../Components/GraphLabel2";


export default function WarehouseDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Warehouse Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Dashboard</h2>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
        <CardRender comp={WarehouseCardData} />
      </div>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">MONTHLY INCOMING ITEMS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel2 color={["#527DFF","#3FD600"]} 
            value={['Item worth', 'Number of items']}
            />
          <SingleLineChart data={WareHouseLineData}/>
        </div>
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="chart-head">
              <h1 className="Graph_title">RECEIVED BY SUPPLIERS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel2 color={["#394A7E","#4E6DCB"]} 
            value={['Recieved', 'Left']}
            />
          <WarehouseBarChart/>
          {/* <StackedBarChart/> */}
        </div>
      </div>

      {/* Here I rendered the dashboard table1 */}

      <WarehouseDashTable />
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">PICKING ACCURACY</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <PieGraph />
        </div>
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">WAREHOUSING COSTS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <PieGraph />
        </div>
      </div>
    </>
  );
}
